import { useRef, useState } from 'react';

import Block from 'shopper/components/Block';
import Button from 'shopper/components/Button';
import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

import StoresDropdown from './StoresDropdown';

import TOPBAR from 'constants/topbar';
import Z_INDEX_SCALE from 'constants/zIndexScale';

const StoresDropdownButton = () => {
  const [isStoresOpen, setStoresOpen] = useState(false);
  const storesButtonRef = useRef(null);

  return (
    <Block
      position="relative"
      zIndex={isStoresOpen ? Z_INDEX_SCALE.SIZE_6 : 'unset'}
    >
      <Button
        data-test-selector="open-stores-dropdown"
        size="size3"
        mr={2}
        type={isStoresOpen ? 'subtle' : 'ghost'}
        iconRight={
          isStoresOpen ? <Icon name="arrow-up" /> : <Icon name="arrow-down" />
        }
        ref={storesButtonRef}
        position={isStoresOpen ? 'relative' : 'unset'}
        zIndex={isStoresOpen ? Z_INDEX_SCALE.SIZE_6 : 'unset'}
        onClick={() => setStoresOpen((prev) => !prev)}
      >
        <Text>{TOPBAR.BUTTON_STORE}</Text>
      </Button>
      <StoresDropdown
        isOpen={isStoresOpen}
        openerRef={storesButtonRef}
        onClose={() => setStoresOpen(false)}
      />
    </Block>
  );
};

export default StoresDropdownButton;
